import { Alert } from "antd";

export default function AlertComponent(props) {
  return <Alert {...props} />;
}
